<template>
  <div>
    <YesNoModal ref="YesNoModal"/>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <Loader ref="Loader"></Loader>
    <v-container fluid grid-list-xs>
      <!-- <v-layout>
            <v-flex xs12 sm12 text-xs-center>
                <h3 style="font-size: 2em;">{{ TranslateText("User Maintenance")}}</h3>
                <br>
            </v-flex>
      </v-layout>-->
      <v-layout justify-center wrap>
        <v-flex md12>
          <v-card>
            <v-btn
              v-if="HasAccess('ROLE_MANAGEMENT', 'CREATE')"
              style="float:right;"
              color="success --darken-2"
              @click="$router.push('/roles/create')"
            >
              <v-icon>add</v-icon>
              Add Role
            </v-btn>
            <v-data-table :headers="headers" :items="items" :search="search">
              <template slot="no-data">There are no records</template>
              <template slot="no-results">No matching records found</template>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td>{{ props.index+1 }}</td>
                <td>{{ props.item.Name }}</td>
                <td>{{ props.item.Master }}</td>
                <td style="float:right;">
                  <v-menu dense bottom left v-if="props.item.Master == false">
                    <v-btn small slot="activator" color="primary" dark>
                      <v-icon>settings</v-icon>
                    </v-btn>

                    <div
                      v-if="HasAccess('ROLE_MANAGEMENT', 'MODIFY') || HasAccess('ROLE_MANAGEMENT', 'DELETE') || HasAccess('PERMISSION_MANAGEMENT', 'MODIFY')"
                    >
                      <v-list dense v-for="(action, index) in actionItems" :key="index">
                        <v-list-tile
                          @click="PerformOperation(action, props.item)"
                          v-if="action.access == true"
                        >
                          <v-list-tile-action>
                            <v-icon color="primary darken-2">{{ action.icon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </div>
                    <div v-else>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-title>
                            You have no options
                            available
                            
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </div>
                  </v-menu>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import JWT from 'jsonwebtoken';

export default {
  data() {
    let self = this;

    return {
      actionItems: [
        {
          type: "modify",
          title: "Modify",
          access: self.HasAccess("ROLE_MANAGEMENT", "MODIFY"),
          icon: "edit"
        },
        {
          type: "permissions",
          title: "Change permissions",
          access: self.HasAccess("PERMISSION_MANAGEMENT", "MODIFY"),
          icon: "lock_open"
        },
        {
          type: "delete",
          title: "Delete",
          access: self.HasAccess("ROLE_MANAGEMENT", "DELETE"),
          icon: "delete"
        }
      ],
      headers: [
        {

        },
        {
          sortable: false,
          text: "Name",
          value: "Name"
        },
        {
          sortable: false,
          text: "Is Master",
          value: "Master"
        },
        {
          sortable: false,
          align: "right",
          text: "Actions"
        }
      ],
      items: [],
      accountID: 0
    };
  },
  props: {
    search: String,
  },
  mounted() {
    let self = this;
    self.accountID = JWT.decode(localStorage.refreshToken).ACCOUNT_ID;
    self.FetchData();
  },
  methods: {
    FetchData() {
      let self = this;
      self.$refs.Loader.show(true);
      self.$refs.Loader.setText("Loading roles...");
      self
        .get(`Roles/Account?accountID=${self.accountID}`)
        .then(response => {
          self.$refs.Loader.hide();
          self.items = response.data;
        })
        .catch(error => {
          self.$refs.Loader.hide();
          self.$refs.ErrorModal.show();
          self.$refs.ErrorModal.setText(error.toString());
          self.items = [];
        });
    },
    PerformOperation(action, item) {
      let self = this;
      switch (action.type.toUpperCase()) {
        case "MODIFY":
          {
            self.modifyitem(item);
          }
          break;
        case "PERMISSIONS":
          {
            self.changePermissions(item);
          }
          break;
        case "DELETE":
          {
            self.deleteItem(item);
          }
          break;
      }
    },
    modifyitem(item) {
      let self = this;
      self.$router.push("/roles/modify/" + item.ID);
    },
    changePermissions(item) {
      let self = this;
      self.$router.push("/roles/permissions/" + item.ID);
    },
    deleteItem(item) {
      let self = this;
      self.$refs.YesNoModal.show(
        "Are you sure you want to delete this role?",
        function(yes) {
          if (yes == true) {
            self.$refs.Loader.show(true);
            self.$refs.Loader.setText("Deleting role...");
            self
              .delete(`Roles?id=${item.ID}`)
              .then(result => {
                self.$refs.Loader.hide();

                if (result.data == true) {
                  var index = self.items.indexOf(item);
                  if (index > -1) {
                    self.items.splice(index, 1);
                  }
                }
              })
              .catch(error => {
                self.$refs.Loader.hide();
                self.$refs.ErrorModal.show();
                self.$refs.ErrorModal.setText(error.toString());
              });
          }
        }
      );
    }
  }
};
</script>